import { AppBar, SxProps } from "@mui/material";
import { FC } from "react";
import APSLogo from "./APSLogo";

const style: SxProps = {
  padding: 2,
  paddingBottom: "2rem",
  m: 0,
  bgcolor: "#ffffff"
};

const PPAppBar: FC<{}> = () => {
  return (
    <AppBar elevation={0} position="static" sx={{ ...style }}>
      <APSLogo/>
    </AppBar>
  );
};

export default PPAppBar;
//PPAppBar.whyDidYouRender = true;